import {PredefinedBaseConfiguration} from './PredefinedBaseConfiguration';

export class TableCleanerConfiguration extends PredefinedBaseConfiguration {
tableName: string;
}

